import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { throwErrorWithId } from '@pypestream/utils';

/**
 * `data` may be bytes: a custom asset folder can hold an image or a font, and passing those
 * as a string round-trips them through a text decode that corrupts them.
 */
export const downloadZip = async (
  fileName: string,
  files: { name: string; data: string | Uint8Array }[]
) => {
  const zip = new JSZip();
  const rootFolder = zip.folder(fileName);

  // The nullable half of the type belongs to THIS overload, not to another
  // one: jszip 3.10.1 declares `folder(name: string): JSZip | null`
  // (index.d.ts:245) and `folder(name: RegExp): JSZip.JSZipObject[]`
  // (index.d.ts:253). Resolving silently with nothing zipped and nothing
  // saved would let a caller's `solution_downloaded` capture claim a download
  // that never happened.
  if (!rootFolder) {
    throwErrorWithId('Could not create ZIP root folder');
    return;
  }

  files.forEach(({ name, data }) => {
    rootFolder.file(name, data);
  });

  const blob = await zip.generateAsync({ type: 'blob' });
  saveAs(blob, `${fileName}.zip`);
};
